import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { RichText, stripMarkdown } from "@/components/RichText";

interface FAQAccordionProps {
  items: { q: string; a: string }[];
  idPrefix?: string;
}

export function FAQAccordion({ items, idPrefix = "faq" }: FAQAccordionProps) {
  return (
    <Accordion type="single" collapsible className="w-full">
      {items.map((item, i) => (
        <AccordionItem key={i} value={`${idPrefix}-${i}`}>
          <AccordionTrigger className="text-left font-semibold text-base md:text-lg">{stripMarkdown(item.q)}</AccordionTrigger>
          <AccordionContent className="text-muted-foreground leading-relaxed">
            <RichText text={item.a} />
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
